<script>
    import { onMount } from 'svelte';
    import { writable } from 'svelte/store';
    import { btn, dbtn } from './buttons.js';
    import Meter from './level_meter.svelte';
	import { CircleDot, CircleStop, Check, Camera, Mic } from '@lucide/svelte';
    import { set_ldc, done, donex, annotatex } from '../lib/ldcjs/waveform/modification1';
    import { refreshToken, getSignedUrlPromise, s3url, gets3 } from '../lib/ldcjs/aws_helper';
    import { fromCognitoIdentity } from "@aws-sdk/credential-provider-cognito-identity";
    import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
    import { TranscribeClient } from "@aws-sdk/client-transcribe";
    import { S3Client, GetObjectCommand, HeadObjectCommand, ListObjectsV2Command, PutObjectCommand } from "@aws-sdk/client-s3";
    import { Upload } from "@aws-sdk/lib-storage";
    import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
    import { request_animation_frame_loop_init } from '../lib/ldcjs/request_animation_frame_loop';
    import {
		set_audio_element_with_url,
		play_src_with_audio_id,
		getUserMedia,
		create_blob,
		filename_from_date,
		create_node_graph,
		get_audio_context
        // play_callback,
        // callf,
        // is_playing,
        // set_playback_rate,
        // set_audio_element,
        // set_audio_id_to_channel,
        // decode_audio_data,
        // stop_playing
    } from '../lib/ldcjs/audio/main';
	import { WaveRiff } from '../lib/ldcjs/audio/wave_riff';
    import AudioPlayer from './audio_player.svelte'
    let page = $state(0);

    function finish(){
        // window.location.href = "https://app.prolific.com/submissions/complete?cc=C7HFMP19"
        alert("disabled")
    }

        let i = window.ldc.last_iid + 1;

    function annotatef(fn){
        annotatex('List', "add", `${i}:ListItem,${i+1}:File`);
        annotatex(`${i+1}`, 'change', { value: fn });
        i += 2;
    }
    set_ldc(window.ldc);

    const choices = [
        '0: None',
        '1: Very Mild',
        '2: Mild',
        '3: Moderate',
        '4: Severe',
        '5: Very Severe'
    ];

    function b(){
        page++;
    }

    refreshToken({
        fromCognitoIdentity,
        CognitoIdentityClient,
        TranscribeClient,
        S3Client,
        GetObjectCommand,
        HeadObjectCommand,
        ListObjectsV2Command,
        PutObjectCommand,
        Upload,
        getSignedUrl
    });
    
    // import { stream_store } from '$lib/stores'
    const stream_store = writable(null);
    let stream = $state();
    stream_store.subscribe( (x) => stream = x );


	let new_builder = () => new WaveRiff('builder');

	let stream_record = 'stream';
	let streaming = $state(false);
    let streamed_once = $state(false);
	let record = $state(false);
	let recording_object = {};
    let chunks = [];
    let blob = $state();
    let filename = '';


	onMount( async () => {
		// const m = await import(`${ldcjs}/request_animation_frame_loop.js`);
		request_animation_frame_loop_init();
		window.ldc.vars.loop.set('time_callback', timef);
    });

    let start_time = 0;
	let seconds = $state(0);
    let seconds_integer = $derived(Math.round(seconds));
	function timef(){
		if(start_time) seconds = (Date.now() - start_time)/1000;
	}

	// $: show_recording = chunks.length;
	// let show_recorder = true;


	let meter_level = $state(0);
    let reset_meter = $state(0);
	// the data processing function sets an RMS value in a meter
	const analyzef = (time_domain, freq_domain) => meter_level = rms(time_domain);
	// const analyzef = () => console.log('here');
	const onstopf = () => console.log('done');

	let audio_context;
	async function audio_context_init(){
		if(!audio_context){
	 		audio_context = get_audio_context();
	    	await audio_context.resume();
			await audio_context.audioWorklet.addModule('/recording_processor.js');
		}
		return audio_context;
	}

	async function start_simple(){
        meter_level = 0;
        reset_meter++;
        const fn = filename_from_date();
        filename = `${fn}`;
		start_recording(stream_record);
	}

    function page2(){
        page = 2;
        start_simple2();
    }

    function page3(){
        page = 3;
        stop_simple2();
    }

    function page4(){
        blob = null;
        page = 4;
        start_simple2();
    }

    function page5(){
        page = 5;
        stop_simple2();
    }

    function start_simple2(){
        stream_record = 'record';
        const fn = filename_from_date();
        filename = `${fn}`;
		start_recording(stream_record);
    }

	async function start_recording(stream_record){
		start_time = Date.now();
        streaming = true;
        streamed_once = true;
        if(stream_record == 'record'){
            record = true;
			await audio_context_init();
        }
        const script_processor = false;
        const audio_worklet = true;
        recording_object = create_node_graph({
            stream,
            record,
            onstopf,
            analyzef,
            script_processor,
            audio_worklet
        });
        // the following assignment is what sets the callback to be called

        window.ldc.vars.loop.set('stream_callback', recording_object.analyze);

		if(recording_object.worklet){
			recording_object.worklet.port.onmessage = (e) => {
				console.log(e);
				chunks = e.data;
		        if(chunks.length){
        		    blob = create_blob(chunks, new_builder());
            		console.log(blob);
        		}
			}
		}
        else{
            console.log('no worklet');
        }
    }

	function stop_simple(){
		stop_recording();
	}

    let uploading = $state(0);
    let uploadProgress = $state(0);
    let uploadStatus = $state('');
    let isUploading = $state(false);
    async function stop_simple2(){
		stop_recording();
        uploading = 1;
        await upload();
        uploading = 2;
	}

    function stop_recording(){
		start_time = 0;
        streaming = false;
        record = false;
        // stream = null;
		if(recording_object){
			recording_object.destroy();
			window.ldc.vars.loop.delete('stream_callback'); // stop callback
		}
    }

	function rms(time_domain){
		let sum = 0;
		for(let i = 0; i < time_domain.length; i++){
			let v = Math.abs(time_domain[i]);
			sum += v * v;
		}
		return Math.sqrt(sum / time_domain.length);
	}

    let levels_ok = $state(false);
    function levels_okf(){
        levels_ok = true;
        page++;
    }

    function upload(){
        if(blob) upload2();
        else setTimeout(upload, 500);
    }

    async function upload2(){
        if(!blob) return;
        await upload3(blob);
        blob = null;
    }

    async function upload3(file){
        console.log(file);
        // const fn = `test${Math.random().toString.substring(2,12)}.wav`
        const fn = `ldcplus/recordings/${window.ldc.vars.user_id}/${filename}.wav`;
        console.log(fn)
        annotatef(fn);
        uploadObject('coghealth', fn, file);
    }

    function uploadObject(Bucket, Key, Body){
        return gets3().then((s3) => {
            isUploading = true;
            uploadProgress = 0;
            uploadStatus = 'Starting upload...';
            
            const upload = new Upload({
                client: s3,
                params: {
                    Bucket,
                    Key,
                    Body,
                },
            });
            
            // Track upload progress
            upload.on("httpUploadProgress", (progress) => {
                uploadProgress = Math.round((progress.loaded / progress.total) * 100);
                uploadStatus = `Uploading... ${uploadProgress}%`;
                console.log(`Upload progress: ${uploadProgress}%`);
            });
            
            return upload.done().then((result) => {
                uploadStatus = 'Upload completed!';
                uploadProgress = 100;
                setTimeout(() => {
                    isUploading = false;
                    uploadStatus = '';
                    uploadProgress = 0;
                }, 2000); // Hide progress after 2 seconds
                return result;
            }).catch((error) => {
                uploadStatus = 'Upload failed!';
                console.error('Upload error:', error);
                setTimeout(() => {
                    isUploading = false;
                    uploadStatus = '';
                    uploadProgress = 0;
                }, 3000); // Hide error after 3 seconds
                throw error;
            });
        });
    }



    let kit = true;
    let streamp = $state();
	const constraints = {
        audio: true,
        video: false
    };
    async function access_hardware(){
		if(!streamp) streamp = navigator.mediaDevices.getUserMedia(constraints);
		streamp.then( (x) => stream_store.set(x) );
	}

    const listmap = new Map();
    let list = $state([]);
    ldc.node_lists.get('List').subscribe((x) => {
        let del = false;
        for(const [k, v] of listmap){
            if(!x.has(k)){
                del = true
                v.File();
                listmap.delete(k);
            }
        }
        if(del) refresh();
        let i = -1;
        for(const [k, v] of x){
            i++;
            if(listmap.has(k)){
            }
            else{
                const c1 = {
                    id: `unsorted-${i}`,
                    iid: k,
                    nodes: v.nodes
                }
                listmap.set(k, c1);
                c1.File = v.nodes.get('File').node_value.subscribe( (x) => {
                    c1.file = x//.value;
                    refresh();
                    console.log('subf')
                    console.log(c1)
                } );
            }
        }
    });
    function refresh(){
        let a = [];
        for(const [k, v] of listmap){
            a.push(v);
        }
        list = a;
    }

    // let checkp = $state();
    let url = $state();
    function checkf(x){
        getSignedUrlPromise('coghealth', x).then(x => url = x);
    }

</script>

<div class="flex justify-center">
	<!-- <button class="{btn} flex" onclick={access_hardware}><Mic/><Camera/><span>Access Hardware</span></button> -->
	{#if stream}
    	<div class="flex"><Mic/>mic is on</div>
    {:else}
    	<button class="{btn} flex" onclick={access_hardware}><Mic/><span>Access Mic</span></button>
	{/if}
    {#if record}
        <div>recording for {seconds_integer} seconds</div>
    {/if}
</div>

<!-- {#if blob}
    <AudioPlayer url=null {blob} filename="foo" />
{:else}
    no blob
{/if} -->

{#snippet header(x)}
    <h1 class="text-2xl font-bold text-blue-600 mb-6 pb-3 border-b-2 border-blue-200 bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4 rounded-lg shadow-sm">
        {x}
    </h1>
{/snippet}

{#snippet p(x)}
    <div class="x">
        {x}
    </div>
{/snippet}
    <!-- <button class="{btn}" onclick={annotatef}>annotate</button> -->
    <!-- <button class="{btn}" onclick={donex}>done</button> -->


<div class="gridx">
    <div class="gridx">
        {#if page == 0}
            <div class="w-1/4 mx-auto p-4 space-y-4 grid-cols-12 gridx">
                {#if !stream}
                    <div class="text-center">Turn on mic acess (button above)</div>
                {:else}
                    {#if !levels_ok}
                        {#key reset_meter}
                            <Meter v={meter_level} clipped={.99} navg={10} />
                        {/key}
                        {#if streaming}
                            <div><button class="{btn} flex space-x-2"  onclick={stop_simple}><CircleStop/><span>Stop</span></button></div>
                        {:else}
                            <div><button class="{btn} flex space-x-2" onclick={start_simple}><CircleDot/><span>Start</span></button></div>
                            {#if streamed_once}
                                <div><button class="{btn} flex space-x-2"  onclick={levels_okf}><Check/><span>Levels ok?</span></button></div>
                            {/if}
                        {/if}
                    {:else}
                        levels ok
                        <!-- <button class="{btn}" onclick={start_simple2}><CircleDot/><span>Start</span></button>
                        <Meter v={meter_level} clipped={.99} />
                        <div><button class="{btn}"  onclick={stop_simple2}><CircleStop/><span>Stop</span></button></div>
                        <div>Read four times:</div>
                        <ol>
                            <li>crisp, fast</li>
                            <li>crisp, slow</li>
                            <li>slurred, fast</li>
                            <li>slurred, slow</li>
                        </ol>
                        {#if uploading > 1}
                            uploading...
                        {/if}
                        {#if uploading == 2}
                            complete
                        {/if} -->
                        <!-- <div><button class="btn variant-filled"  onclick={() => levels_ok = true}><Check/><span>Levels ok?</span></button></div> -->
                    {/if}
                {/if}
            </div>
        {/if}
        {#if page > 0}
            <div class="w-3/4 mx-auto p-4 space-y-2 grid-cols-12 gridx">
                {#if page == 1}
                    {@render header("Instructions")}
                    <div class="flex">
                    <!-- <div class="text-gray-700 leading-relaxed mb-4 px-2 py-2 bg-white bg-opacity-50 rounded-md shadow-sm border-l-4 border-gray-200 hover:border-blue-300 transition-colors duration-200"> -->
                        {@render p("Please read the shark text below silently to yourself.\
                        We'll record you saying it twice, once quickly, and once eloquently.\
                        When you're ready, hit Record, read it quickly, and hit Stop when done.\
                        After that, you'll be prompted to record again.")}
                    <!-- </div> -->
                        <button class="{btn}" onclick={page2}>Record</button>
                    </div>
                {:else if page == 2}
                    {@render header("Instructions")}
                    <div class="flex">
                        {@render p("Read quickly, and then hit Stop")}
                        <button class="{btn}" onclick={page3}>Stop</button>
                    </div>
                {:else if page == 3}
                    {@render header("Instructions")}
                    <div class="flex">
                        {@render p("When ready, hit Record and read eloquently.")}
                        <button class="{btn}" onclick={page4}>Record</button>
                    </div>
                {:else if page == 4}
                    {@render header("Instructions")}
                    <div class="flex">
                        {@render p("Read eloquently, and then hit Stop")}
                        <button class="{btn}" onclick={page5}>Stop</button>
                    </div>
                {:else if page == 5}
                    <div class="flexx">
                        {@render header("Thank you!")}
                        {#if !isUploading}
                            <button class="{btn}" onclick={donex}>done</button>
                        {/if}
                    </div>
                {/if}
                
                <!-- Upload Progress Display -->
                {#if isUploading}
                    <div class="bg-white border rounded-lg p-4 mb-4 mx-auto max-w-md">
                        <div class="flex items-center justify-between mb-2">
                            <span class="text-sm font-medium text-gray-700">{uploadStatus}</span>
                            <span class="text-sm text-gray-500">{uploadProgress}%</span>
                        </div>
                        
                        <div class="w-full bg-gray-200 rounded-full h-2">
                            <div 
                                class="bg-blue-600 h-2 rounded-full transition-all duration-300 ease-out"
                                style="width: {uploadProgress}%"
                            ></div>
                        </div>
                        
                        {#if uploadProgress > 0 && uploadProgress < 100}
                            <p class="text-xs text-gray-500 mt-1">
                                Uploading audio file...
                            </p>
                        {/if}
                    </div>
                {/if}
                {#if page > 0 && page < 5}
                    {@render header("Shark Text")}
                    {@render p("What's scarier than a shark? Imagine those beady eyes coming straight at you. Those eyes never blink. The shark's mouth is a mean looking slit. The big fin on the shark's back is like a knife cutting through the water.")}
                    {@render p("When the shark opens its mouth, you see rows and rows of razor sharp teeth. Yes, sharks are killers. A shark is at the top of the food chain in the ocean. They eat lots of other creatures and almost nothing eats them.")}
                    {@render p("But did you know that you are more likely to be harmed by a vending machine falling on top of you than by a shark attack? A shark is frightening, but the fact is that they almost never harm people.")}
                    {@render p("There are hundreds of different kinds of sharks. Some sharks are longer than a school bus, while others are so small they can live in your fish tank. Sharks come in all kinds of colors. Over time, a shark's skin has adapted to a color or pattern that helps them blend in with their surroundings.")}
                    {@render p("A shark is a very remarkable fish. The sharks that live in the deepest ocean glow in the dark. Sharks have no bones. Their skeleton is just cartilage, like the bridge of your nose.")}
                    {@render p("Like all fish, sharks breathe through slits called gills. To breathe, a shark must move. So if a shark is unable to swim, it will quickly die.")}
                    {@render p("When most people think about sharks, they see teeth. You have one row of teeth. Sharks have row after row. As time passes, the front teeth that crunch on prey fall out and the teeth in the back rows move forward. Some sharks lose thirty thousand teeth over their lifetime!")}
                {:else if page == 5}
                    {#if url}
                        {#key url}
                            <div class="flex justify-center">
                                <div>
                                <AudioPlayer {url} blob={null} filename="foo" />
                                </div>
                            </div>
                        {/key}
                    {/if}
                    {#each list as x}
                        <div class="flex justify-center">
                            <div>{x.file.value}</div>
                            <div><button class="{btn}" onclick={() => checkf(x.file.value)}>Check</button></div>
                        </div>
                    {/each}
                {/if}
            </div>
        {/if}

    </div>
</div>



